import React from 'react';
import { MessageSquareDashedIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-166" data-mp="20qnnnpi6mhol">
      <Reveal className="mx-auto max-w-6xl" data-id="element-167" data-mp="1n0tzl9ei41fx">
        <div className="mb-12 text-center" data-id="element-168" data-mp="1mzsd88s1bsiw">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-169" data-mp="1r141oaz6a7pi">VOCI DALLE AULE</p>
          <h2 className="text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-170" data-mp="1d1l76kzaauvo">Cosa Dicono gli Insegnanti di Arte</h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-171" data-mp="1i2ines0qheuj">
          {[0, 1, 2].map(slot => <article key={slot} className="flex min-h-[180px] flex-col items-center justify-center rounded-2xl border border-dashed border-brand-dark bg-brand-main p-7 text-center" data-id="element-172" data-mp="142hlracna3e0">
              <MessageSquareDashedIcon className="h-7 w-7 text-brand-gray/60" strokeWidth={1.5} aria-hidden="true" data-id="element-173" data-mp="2yd33ynyvh9ak" />
              <p className="mt-4 font-display text-lg font-semibold text-brand-gray" data-id="element-174" data-mp="2v1krso7d49vr">Recensione in arrivo</p>
            </article>)}
        </div>
        <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-brand-gray" data-id="element-175" data-mp="2q1q1omvevobr">
          Le testimonianze verranno pubblicate appena raccolte da insegnanti che hanno provato ARTE PRONTA™.
        </p>
      </Reveal>
    </section>;
}